import React from "react";
import {Route} from "react-router-dom";
import KeepAlive from "react-activation";
import ChuangShiOS from "chuangshi-os-website-component";

import CouponIndex from "./Index";
import CouponDetail from "./Detail";

const data = [
    <Route
        exact
        key="CouponIndex"
        path="/coupon/index"
        render={(props) => {
            ChuangShiOS.Util.validateToken(props);
            return (
                <KeepAlive name="/goods/index">
                    <CouponIndex {...props} />
                </KeepAlive>
            );
        }}
    />,
    <Route
        exact
        key="CouponAdd"
        path="/coupon/add"
        render={(props) => {
            ChuangShiOS.Util.validateToken(props);
            return <CouponDetail {...props} />;
        }}
    />,

];

export default data;
